<template>
  <div class="lang-choose"
    @click="triggerBtn">
    <div class="img-wrap">
      <img class="earth" src="/images/footer-earth.png" alt="">
      <img class="earth-light" src="/images/footer-earth-light.png" alt="">
    </div>

    <!-- <div class="info ft-14">语言：中国大陆</div> -->
    <div class="info ft-14">{{ $t('chooseLang') }}</div>
  </div>
</template>

<script>
export default {
  methods: {
    triggerBtn () {
      this.$emit('trigger-lang')
    }
  }
}
</script>

<style lang="scss" scoped>
.lang-choose {
  cursor: pointer;
  margin: 16px;
  padding: 16px;
  display: flex;
  justify-content: center;

  .img-wrap {
    width: 21px;
    height: 21px;
    position: relative;

    .earth {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 1;
      transition: opacity 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
    }

    .earth-light {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      transition: opacity 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
    }
  }

  .info {
    color: #000;
    margin-left: 12px;
    transition: color 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  }
}

.lang-choose:hover {
  .img-wrap {
    .earth {
      opacity: 0;
    }

    .earth-light {
      opacity: 1;
    }
  }

  .info {
    color: #8fd6ed;
  }
}
</style>
